/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {mergeClasses} from "../../../utils";
import {BootstrapVariation} from "../../../utils/boostrap";
import {WithConfirmation} from "../../hoc/withConfirmation";
import Tooltip from "../layout/Tooltip";

export class Button extends React.Component {

    static defaultProps = {
        disabled: false,
        classes: []
    };

    static colors = {
        PRIMARY: "primary",
        SECONDARY: "secondary",
        SECONDARY_INVERTED: "secondary-inverted",
        DEFAULT: "default"
    };

    static propTypes = {
        block: PropTypes.bool,
        color: PropTypes.oneOf(Object.values(Button.colors)),
        onClick: PropTypes.func.isRequired,
        disabled: PropTypes.bool,
        className: PropTypes.string,
        square: PropTypes.bool,
        children: PropTypes.any,
        classes: PropTypes.array,
    };

    render() {
        const {children, square, block, color, onClick, disabled, className, size, inverted, mouseEvent} = this.props;

        return (<div className={mergeClasses([
            "btn",
            block && "btn-block",
            color && "btn-" + color,
            size && "btn-" + size,
            square && "btn-square",
            inverted && "btn-inverted",
            disabled && "btn-disabled disabled",
            className
        ])} onClick={disabled ? null : onClick} onMouseEnter={mouseEvent} onMouseLeave={mouseEvent}>
            {children}
        </div>);
    }

}


export function AddToCartButton({color = "", loading, disabled, response, className = "", noRemainingQuantity = false, translate = undefined, icon = undefined, text = undefined, small = false, onClick, ...props}) {
    const quantityMsg = "You have reached the maximum number of times this item can be purchased";
    const [buttonAnimationActive, setButtonAnimationActive] = useState(false);

    useEffect(() => {
        if (loading) {
            setButtonAnimationActive(true);
        }

        let fxTimeout = null;
        if (!loading && buttonAnimationActive) {
            fxTimeout = setTimeout(() =>
                setButtonAnimationActive(false),
                3000
            )
        }

        return () => clearTimeout(fxTimeout);
    },[loading]);

    return <Tooltip placement="auto" trigger="hover" tooltip={translate ? translate(quantityMsg) : quantityMsg}
                    disabled={!noRemainingQuantity}>
        {small ?
            <WithConfirmation confirmation={loading} response={response}>
                <a className={`btn-add-to-cart ${disabled ? "disabled" : ""}`}
                   href="#!" onClick={onClick}>
                    <span className="btn-add-to-cart__holder btn-add-to-cart__icon"/>
                </a>
            </WithConfirmation>
            :
            <Button color={BootstrapVariation.primary} onClick={onClick}
                    className={disabled ? (className || "") + " disabled" + (buttonAnimationActive ? " button-animation-active" : "") : (className || "") + (buttonAnimationActive ? " button-animation-active badge-success" : "")} {...props}>
                <WithConfirmation confirmation={loading} response={response} longButton>
                    {icon ? <span className={`svg-shopping-cart-white hidden-if-not-only`}/> : ''}{(translate && text ? translate(text) : text) ?? <div className="p-flex">+ <span className="svg-shopping-cart-white p-margin-left-sm"/></div>}
                </WithConfirmation>
            </Button>
        }
    </Tooltip>
}
